import React from "react";
import { Link } from "react-router-dom";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import StatusCard from "./StatusCard";

type Props = { isSuperAdmin: boolean };

const NoWebsite: React.FC<Props> = ({ isSuperAdmin }) => (
    <StatusCard
        accentColor="var(--st-warn)"
        icon={faTriangleExclamation}
        title="Nemáte pridelenú stránku"
        text="Kontaktujte administrátora systému a požiadajte o pridelenie stránky."
        minHeight="82vh"
        action={isSuperAdmin ? (
            <Link
                to="/user/table"
                className="st-btn st-btn--tint"
                style={{ '--btn-accent': 'var(--st-warn)' } as React.CSSProperties}
            >
                Správa používateľov
            </Link>
        ) : undefined}
    />
);

export default NoWebsite;
